// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Ss9wJ","date":"styles_date__pDa8O","links_wrapper":"styles_links_wrapper__lQS+A"};